import { useEffect, useState } from 'react';
import axios from 'axios';
import ITEM from './scorecard-item';

export default function Scorecard({ context, items, onItemsChange, isCompleted }) {
  const [previous, setPrevious] = useState([]);
  const [quarter, setQuarter] = useState(null);
  const [error, setError] = useState('');
  const [retry, setRetry] = useState(0);
  const { year_id, roundup_number } = context;
  useEffect(() => {
    let cancelled = false;
    axios.post(`${process.env.REACT_APP_WEB_URL}api/roundups/underway/get-previous-scorecards`, { year_id, roundup_number }, { withCredentials: true })
      .then(({ data }) => {
        if (cancelled) return;
        if (!Array.isArray(data.fetchedRoundupScorecard)) throw new Error();
        setPrevious(data.fetchedRoundupScorecard); setQuarter(data.quarterNumber); setError('');
      }).catch(() => { if (!cancelled) setError('Unable to load previous roundups.'); });
    return () => { cancelled = true; };
  }, [year_id, roundup_number, retry]);
  const change = (index, value) => onItemsChange(items.map((item, i) => i === index ? { ...item, value: Number(value) || 0 } : item))?.catch(() => {});

  return <div>
    <h2>Scorecard{quarter ? ` · Quarter ${quarter}` : ''}</h2>
    <p>History and averages cover this quarter. Earlier quarters remain saved. Each week belongs to the quarter in which it starts.</p>
    {error && <p role="alert">{error} <button onClick={() => setRetry(value => value + 1)}>Try again</button></p>}
    <div className="roundup-table-scroll"><table className="roundup-scorecard"><caption>Roundup {roundup_number}{quarter ? ` — Quarter ${quarter}` : ''}</caption>
      <thead><tr><th>Item</th><th>Aim</th><th>Quarter average</th>{previous.map(roundup => <th key={roundup._id}>Week {roundup.roundup_number}</th>)}<th>This week</th></tr></thead>
      <tbody>{items.length ? items.map((item, index) => <ITEM key={index} item={item} index={index} previousRoundups={previous} handleValueBlur={change} isCompleted={isCompleted} />) : <tr><td colSpan={4 + previous.length}>No scorecard items. Add them on the planning screen.</td></tr>}</tbody>
    </table></div>
  </div>;
}
